const o = {
  editorial: {
    style: "editorial",
    personality: "editorial"
  },
  nature: {
    brand: "nature",
    style: "editorial",
    personality: "editorial"
  },
  illustration: {
    theme: "illustration",
    style: "illustration",
    personality: "illustration"
  },
  neumorphism: {
    style: "neumorphism",
    personality: "neumorphism"
  },
  acme: {
    theme: "acme"
  }
};
function l(t) {
  return t.preset && o[t.preset] ? { ...o[t.preset], ...t } : t;
}
function u(t) {
  if (typeof document > "u") return;
  const e = document.documentElement, { mode: r, brand: i, style: a, theme: s, personality: n } = l(t);
  r && e.setAttribute("data-mode", r), i && e.setAttribute("data-brand", i), a && e.setAttribute("data-style", a), s && e.setAttribute("data-theme", s), n && e.setAttribute("data-personality", n);
}
export {
  u as a,
  l as r,
  o as t
};
